module.exports = __webpack_public_path__ + "img/FinalReport.f6c2abbe.png";